<template>
  <v-system-bar app height="40" color="primary">
    <v-spacer></v-spacer>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="white" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-account-circle</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" link>
          <v-list-item-title @click="moveTo(item.url)"
            ><v-icon>{{ item.icon }}</v-icon>
            {{ item.title }}</v-list-item-title
          >
        </v-list-item>
        <template>
          <v-btn
            dark
            color="red darken-1"
            @click="logout"

          >
            <v-icon>mdi-logout</v-icon> Logout
          </v-btn>
        </template>
      </v-list>
    </v-menu>
  </v-system-bar>
</template>

<script>
export default {
  name: "AppTopBar",
  data: () => ({
    drawer: true,
    group: null,
    clientId: process.env.VUE_APP_DEMO_CLIENT_ID,
    items: [
      { icon: "mdi-account-edit", url: "/"+process.env.VUE_APP_DEMO_CLIENT_ID+"/profile", title: "ข้อมูลส่วนตัว" },
      { icon: "mdi-wallet-giftcard", url: "/award", title: "ของรางวัล" },
      { icon: "mdi-gift", url: "/"+process.env.VUE_APP_DEMO_CLIENT_ID+"/redeem", title: "แลกของรางวัล" },
      { icon: "mdi-gift-outline", url: "/"+process.env.VUE_APP_DEMO_CLIENT_ID+"/history", title: "ประวัติการแลกของรางวัล" },

      { icon: "mdi-alert-circle-outline", url: "/condition", title: "ข้อกำหนดและเงื่อนไข" },
      //{ icon: "mdi-logout", url: "", title: "Logout" },
    ],
  }),

  methods: {
    logout() {
      console.log("logout");
        this.$router.push("/");
    },
    moveTo(url) {
        this.$router.push(url);
    }
  },

  watch: {
    group() {
      // this.drawer = false
    },
  },
};
</script>